import { Box } from "@stenajs-webui/core";
import { PrimaryButton, stenaPlusCircle } from "@stenajs-webui/elements";
import { ModalFooter } from "@stenajs-webui/modal";
import { useSelector } from "react-redux";

import { trackEvent } from "../../../common/tracking/trackerService";
import { PRINT_HIDE_CLASSNAME } from "../../../globalStyles";
import { getCreateIntermodalBookingIsFetchingJourney } from "../../../services/intermodal/createIntermodalReducer";
import { useCreateIntermodalBooking } from "../../../services/intermodal/hooks/useCreateIntermodalBooking";

interface IntermodalCreateModalFooterProps {
  onClose: () => void;
}

export function IntermodalCreateModalFooter({
  onClose,
}: IntermodalCreateModalFooterProps) {
  const isFetchingJourney = useSelector(
    getCreateIntermodalBookingIsFetchingJourney,
  );
  const { submit, loading } = useCreateIntermodalBooking(onClose);

  const onClick = () => {
    trackEvent({
      action: "Click create booking  ",
      category: "IntermodalCreate",
    });
    submit();
  };

  return (
    <ModalFooter sticky className={PRINT_HIDE_CLASSNAME}>
      <Box
        flex={1}
        flexDirection={["column", null, "row"]}
        justifyContent={"flex-end"}
      >
        <PrimaryButton
          disabled={isFetchingJourney}
          label={"Create booking"}
          className={"t_intermodal_create_booking"}
          leftIcon={stenaPlusCircle}
          onClick={onClick}
          loading={loading}
          loadingLabel={"Saving..."}
        />
      </Box>
    </ModalFooter>
  );
}
